"use client"

import { useUIBuilderLocaleStore } from "@/(admin)/modules/ui-builder/store/useUIBuilderLocaleStore"
import { useParams } from "next/navigation"
import { useMemo } from "react"
import { twMerge } from "tailwind-merge"
import { RegistrationFormContent } from "./components/RegistrationFormContent"

export interface RegistrationFormRenderProps {
    title?: string
    description?: string
    className?: string
    id?: string,
    linkTermsOfService?: string,
}

export const RenderConfig = {
    render: ({ title, description, className, id: componentId, linkTermsOfService }: RegistrationFormRenderProps) => {
        const params = useParams()
        const storeLocale = useUIBuilderLocaleStore(state => state.locale)
        const locale = (params?.locale as string) || storeLocale || "vi"

        const id = useMemo(
            () => componentId || `registration-form-${Math.random().toString(36).substr(2, 9)}`,
            [componentId]
        )

        return (
            <div className={twMerge("w-full flex flex-col gap-[27px]", className)} id={id}>
                <div className="flex flex-col gap-[17px] text-center">
                    <h2 className="sm:text-2xl sm:leading-[37.2px] text-lg leading-[27.9px] font-extrabold text-[#333333]">{title}</h2>
                    <p className="sm:text-base sm:leading-[24.8px] text-xs leading-[18.6px] text-[#333333] font-normal sm:text-center text-justify">{description}</p>
                </div>
                <div className="w-full mx-auto bg-[#0000000D] rounded-lg">
                    <div className="max-w-[700px] sm:py-10 sm:px-0 px-2.5 pt-[15px] pb-[50px] mx-auto">
                        <RegistrationFormContent className={className} linkTermsOfService={linkTermsOfService} locale={locale} />
                    </div>
                </div>
            </div>
        )
    },
}

